import * as yup from 'yup';

export const schema = yup.object({
  username: yup
    .string()
    .required()
    .label('Username / Phone Number')
    .default(''),
  password: yup.string().required().label('Password').default(''),
});
